export default function FarmerDashboard({ data }) {
  const lots = data?.lots || [];

  const totalLots = lots.length;
  const totalQuantity = lots.reduce((sum, l) => sum + l.quantity, 0);
  const avgPrice =
    lots.length > 0
      ? Math.round(lots.reduce((sum, l) => sum + l.price, 0) / lots.length)
      : 0;

  return (
    <div>
      <h2 className="text-xl text-yellow-200 mb-4">Farmer Dashboard</h2>

      {/* SUMMARY CARDS */}
      <div className="grid grid-cols-3 gap-4 mb-4">
        <div className="bg-gray-800 p-3 rounded">
          <p>Total Lots</p>
          <p className="text-lg font-bold">{totalLots}</p>
        </div>

        <div className="bg-gray-800 p-3 rounded">
          <p>Total Quantity</p>
          <p className="text-lg font-bold">{totalQuantity} kg</p>
        </div>

        <div className="bg-gray-800 p-3 rounded">
          <p>Avg Price</p>
          <p className="text-lg font-bold">₹{avgPrice}</p>
        </div>
      </div>

      {/* LOT LIST */}
      <div>
        <h3 className="text-yellow-200 mb-2">Recent Lots</h3>

        {lots.map((lot) => (
          <div key={lot.id} className="bg-gray-900 p-3 mb-2 rounded">
            <p className="font-semibold">{lot.crop}</p>
            <p className="text-sm">
              {lot.farmer} • {lot.quantity}kg • Grade {lot.grade}
            </p>
            <p className="text-sm text-green-400">₹{lot.price}/kg</p>
          </div>
        ))}
      </div>
    </div>
  );
}